import {
  Menu,
  MenuItem,
  FocusableItem,
  ControlledMenu,
  SubMenu,
  MenuButton,
} from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/zoom.css";

import { useSelector, useDispatch } from "react-redux";
import { toolPluginSelectors } from "../../../tools/store/toolPluginReducer";
import { useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { loadToolPlugins } from "../../../tools/store/toolPluginActionCreators";
import { useEffect, useState } from "react";
import { PuzzleIcon } from "lucide-react";
import { Switch } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";

import "./PluginSelector.scss";

const PluginSelector = ({ selectedPlugins, onPluginsChange, isReadOnly = false }) => {
  const { workspaceId } = useParams();
  const dispatch = useDispatch();
  const intl = useIntl();
  const toolPluginList = useSelector(toolPluginSelectors.getList);
  const [showSelectorPanel, setShowSelectorPanel] = useState(false);
  useEffect(() => {
    if (workspaceId) {
      dispatch(loadToolPlugins(intl, workspaceId));
    }
  }, [dispatch, intl, workspaceId]);

  if (!toolPluginList) {
    return null;
  }

  return (
    <div className="plugin_selector_component">
      <div
        className={
          "prompt_textarea_toolbar_action" +
          (selectedPlugins.length > 0 ? " selected" : "") +
          (isReadOnly ? " readonly" : "")
        }
        onClick={() => setShowSelectorPanel(true)}
        title={isReadOnly ? "Plugins are predefined by assistant" : ""}
      >
        <PuzzleIcon
          color={selectedPlugins.length > 0 ? "#8358ff" : "#344767"}
          size={20}
        />
      </div>
      {showSelectorPanel && (
        <div className="selector_panel_container">
          <div
            className="cover"
            onClick={() => setShowSelectorPanel(false)}
          ></div>
          <div className="selector_panel">
            {toolPluginList.map((plugin) => (
              <div className="plugin_selector_item" key={plugin.uid}>
                <PuzzleIcon size={20} />
                <div
                  className="plugin_name"
                  onClick={() => {
                    if (isReadOnly) return;
                    if (!selectedPlugins.includes(plugin.uid)) {
                      onPluginsChange([...selectedPlugins, plugin.uid]);
                    } else {
                      onPluginsChange(
                        selectedPlugins.filter((id) => id !== plugin.uid)
                      );
                    }
                  }}
                >
                  {plugin.name}
                </div>
                <div className="plugin_toggle">
                  <Switch
                    checked={selectedPlugins.includes(plugin.uid)}
                    color="teal"
                    disabled={isReadOnly}
                    onChange={(event) => {
                      if (isReadOnly) return;
                      event.stopPropagation();
                      const isChecked = event.currentTarget.checked;
                      if (isChecked) {
                        if (!selectedPlugins.includes(plugin.uid)) {
                          onPluginsChange([...selectedPlugins, plugin.uid]);
                        }
                      } else {
                        onPluginsChange(
                          selectedPlugins.filter((id) => id !== plugin.uid)
                        );
                      }
                    }}
                    thumbIcon={
                      selectedPlugins.includes(plugin.uid) ? (
                        <IconCheck
                          size={12}
                          color="var(--mantine-color-teal-6)"
                          stroke={3}
                        />
                      ) : (
                        <IconX
                          size={12}
                          color="var(--mantine-color-red-6)"
                          stroke={3}
                        />
                      )
                    }
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PluginSelector;
